import { addTrip as persistTripToFirestore } from './firestoreService';
import { linkRegistryConfigService } from '../services/linkRegistryConfigService';

/**
 * Creates a trip document and writes Phase 3 `_meta/linkRegistry` defaults.
 * Central funnel for package consumers importing `addTrip` from `@trip-planner-monorepo/shared`.
 */
export async function addTrip(userId, tripData) {
  const tripId = await persistTripToFirestore(userId, tripData);
  await linkRegistryConfigService.bootstrapNewTripRegistry(userId, tripId);
  return tripId;
}
